var VariableName = /** @class */ (function () {
    function VariableName(name, variableVersion, groupName) {
        this.name = name;
        this.variableVersion = variableVersion;
        this.groupName = groupName;
        if (!name) {
            throw new Error('name can not be empty or undefined.');
        }
    }
    VariableName.equals = function (x, y) {
        if (x === y) {
            return true;
        }
        if (!x) {
            return false;
        }
        if (!y) {
            return false;
        }
        if (typeof x !== typeof y) {
            return false;
        }
        if (!x.variableVersion || !y.variableVersion) {
            return x.name === y.name;
        }
        return x.name === y.name && x.variableVersion === y.variableVersion;
    };
    VariableName.tryParse = function (name, variableVersion) {
        if (!name) {
            return undefined;
        }
        return new VariableName(name, variableVersion);
    };
    return VariableName;
}());
export { VariableName };
